import ff from './ff';

export default class c10d {

static d_defs = {

/*
  DROP TABLE t_c30r;
  CREATE TABLE t_c30r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER,
    c30rb21f INTEGER,
    c30rbk1f INTEGER,
    c30rc11s TEXT,
    c30rc12s TEXT,
    c30rc31s TEXT,
    c30rc33s TEXT,
    c30ri11s TEXT,
    c30ri13s TEXT,
    c30ri21s TEXT,
    c30ri22i TEXT,
    c30ri31s TEXT,
    c30ri32s TEXT,
    c30ri33s TEXT,
    c30ri34s TEXT,
    c30ri41s TEXT,
    c30ri42s TEXT,
    c30rt21i INTEGER,
    c30ri21i INTEGER,
    c30rt22i INTEGER,
    c30ri51s TEXT,
    c30ri52s TEXT, 
    c30ri53s TEXT,
    c30ri61s TEXT,
    c30ri71d TEXT,
    c30ri71s TEXT,
    c30ri81s TEXT,
    c30ri91i INTEGER,
    c30ri92i INTEGER,
    c30ri93i INTEGER,
    c30ri94s TEXT,
    c30ria1i INTEGER,
    c30rib1i INTEGER,
    c30ric1s TEXT,
    c30rid1s TEXT,
    c30rid2s TEXT,
    c30rie1i INTEGER,
    c30rie2s TEXT,
    c30rie3i INTEGER,
    c30rie4i INTEGER,
    c30rie5i INTEGER,
    c30rif1i INTEGER,
    c30rif1m BIGINT,
    c30rig1s TEXT,
    c30rig2s TEXT,
    c30rig3s TEXT,
    c30rih1i INTEGER,
    c30rih2i INTEGER,
    c30rih3i INTEGER,
    c30rcx1i INTEGER,
    c30rcy1t TEXT,
    c30rcy1f INTEGER,
    c30rcz1i INTEGER
  );
  UPDATE t_c30r SET _fst = _key;
*/

  c30r: {
    0: {
      pfx: '団体情報',
      b_vsn: true,
      d_insFlds: {
        c10rc31s: '',
        c30rc11s: '',
        c30rc31s: '',
        c30rc33s: '',
        c30ri11s: '',
        c30ri13s: '',
        c30ri21s:  0,
        c30rt21i:  0,
        c30rt22i: -1,
        c30ri31s: '',
        c30ri32s: '',
        c30ri33s: '',
        c30ri34s: '',
        c30ri41s: '',
        c30ri42s: '',
        c30ri51s: '',
        c30ri52s: '',
      },
      dd_fldDefss: {
        c30rb21f: {
          pfx: 'c20r_fst',
          type: 'Inp',
        },
        c30rbk1f: { 
          pfx: '団体種別',
          type: 'Pck',
          n_col: 3,
          b_rqr: true,
        },
        c30rc11s: {
          pfx: '団体番号',
          type: 'Inp',
          n_col: 6,
          b_rqr: true,
        },
        c30rc12s: {
          pfx: '団体コード',
          type: 'Inp',
          n_col: 5,
          b_rqr: true,
        },
        c30rc31s: {
          pfx: '団体名',
          type: 'Inp',
          n_col: 15,
//          n_col: 8,
          b_rqr: true,
        },
        c30rc33s: {
          pfx: '団体名かな',
          type: 'Inp',
          n_col: 15,
        },
        c30ri11s: {
          pfx: '代表者名',
          type: 'Inp',
          n_col: 10,
        },
        c30ri13s: {
          pfx: '代表者名かな',
          type: 'Inp',
          n_col: 10,
        },
        c30ri21s: {
          pfx: '利用制限',
          type: 'Pck',
          ld_iss: [
            { key:  -1, pfx: 'なし' },
            { key:  10, pfx: 'WEB予約・エントリー利用を制限' },
          ],
          n_col: 20,
        },
/*
        c30rt21i: {
          pfx: '減免率区分',
          type: 'Pck',
          ld_iss: [
            { key:  -1, pfx: ' ' },
            { key:   0, pfx: 'なし' },
            { key:  50, pfx: '50%' },
            { key: 100, pfx: '100%' },
            { key: 999, pfx: '任意' },
          ],
          n_col: 5,
        },
        c30ri22i: {
          pfx: '減免率',
          type: 'Inp',
          n_col: 5,
        },
        c30rt22i: {
          pfx: '減免理由区分',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: 'A' },
            { key: 20, pfx: 'B' },
            { key: 30, pfx: 'C' },
            { key: 40, pfx: 'D' },
          ],
          n_col: 5,
        },
*/
        c30ri31s: {
          pfx: '郵便番号',
          type: 'Inp',
          n_col: 6,
        },
        c30ri32s: {
          pfx: '都道府県',
          type: 'Inp',
          n_col: 5,
        },
        c30ri33s: {
          pfx: '市区町番地',
          type: 'Inp',
          n_col: 15,
        },
        c30ri34s: {
          pfx: '建物・部屋番等',
          type: 'Inp',
          n_col: 15,
        },
        c30ri41s: {
          pfx: '電話（主）',
          type: 'Inp',
          n_col: 10,
        },
        c30ri42s: {
          pfx: '電話（副）',
          type: 'Inp',
          n_col: 10,
        },
/*
        c30ri51s: { 
          pfx: 'メール(主)',
          type: 'Inp',
          n_col: 15,
          b_rqr: true,
        },
        c30ri52s: { 
          pfx: 'メール(副1)',
          type: 'Inp',
          n_col: 15,
          b_rqr: true,
        },
        c30ri53s: { 
          pfx: 'メール(副2)',
          type: 'Inp',
          n_col: 15,
          b_rqr: true,
        },
*/
        c30ri71d: { 
          pfx: '次回更新日',
          type: 'PckDate',
        },
        c30ri71s: { 
          pfx: '更新メモ',
          type: 'Inp',
          n_col: 62,
        },
        c30ri81s: { 
          pfx: '備考',
          type: 'Inp',
          n_col: 62,
        },
        c30ri91i: { 
          pfx: '活動頻度区分',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '月' },
            { key: 20, pfx: '年' },
          ],
          n_col: 3,
        },
        c30ri92i: { 
          pfx: '活動頻度回数',
          type: 'Inp',
          n_col: 3,
        },
        c30ri93i: { 
          pfx: '活動時間帯',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '午前' },
            { key: 20, pfx: '午後' },
            { key: 30, pfx: '夜間' },
            { key: 90, pfx: 'その他' },
          ],
          n_col: 5,
        },
        c30ri94s: { 
          pfx: '活動曜日',
          type: 'Inp',
          n_col: 15,
        },
        c30ria1i: { 
          pfx: '会員募集',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: 'する' },
            { key:  0, pfx: 'しない' },
          ],
          n_col: 5,
        },
        c30rib1i: { 
          pfx: 'カテゴリ',
          type: 'Pck',
          n_col: 10,
        },
        c30ric1s: { 
          pfx: '活動内容',
          type: 'Inp',
          n_col: 45,
        },
        c30rid1s: { 
          pfx: '指導者名',
          type: 'Inp',
        },
        c30rid2s: { 
          pfx: '指導者名かな',
          type: 'Inp',
        },
        c30rie1i: { 
          pfx: '会員構成分類区分',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '一般' },
            { key: 20, pfx: '事後サークル' },
            { key: 30, pfx: '優先団体' },
            { key: 90, pfx: 'その他' },
          ],
          n_col: 8,
        },
        c30rie2s: { 
          pfx: '会員構成分類その他',
          type: 'Inp',
          n_col: 10,
        },
        c30rie3i: { 
          pfx: '会員構成人数男性',
          type: 'Inp',
          n_col: 3,
        },
        c30rie4i: { 
          pfx: '会員構成人数女性',
          type: 'Inp',
          n_col: 3,
        },
        c30rie5i: { 
          pfx: '会員構成人数こども',
          type: 'Inp',
          n_col: 3,
        },
        c30rif1i: { 
          pfx: '会費分類',
          type: 'Pck',
          n_col: 4,
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '一回' },
            { key: 20, pfx: '月' },
            { key: 30, pfx: '年' },
          ],
        },
        c30rif1m: { 
          pfx: '会費料金',
          type: 'Inp',
          n_col: 4,
        },
        c30rig1s: { 
          pfx: 'メール（主）',
          type: 'Inp',
          n_col: 14,
        },
        c30rig2s: { 
          pfx: 'メール（副1）',
          type: 'Inp',
          n_col: 14,
        },
        c30rig3s: { 
          pfx: 'メール（副2）',
          type: 'Inp',
          n_col: 14,
        },

        c30rih1i: { 
          pfx: '１年目確認',
          type: 'Chk',
          n_col: 3,
          ld_iss: [
            { key: 0, pfx: '未' },
            { key: 1, pfx: '済' },
          ],
        },
        c30rih2i: { 
          pfx: '２年目確認',
          type: 'Chk',
          n_col: 3,
          ld_iss: [
            { key: 0, pfx: '未' },
            { key: 1, pfx: '済' },
          ],
        },
        c30rih3i: { 
          pfx: '３年目確認',
          type: 'Chk',
          n_col: 3,
          ld_iss: [
            { key: 0, pfx: '未' },
            { key: 1, pfx: '済' },
          ],
        },
        c30rBtn1: { 
          pfx: '住所を取得',
          type: 'Btn',
        },
      },
    }


  },

};

};
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
